"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvironmentSpecificIdentityUrl = exports.getEnvironmentSpecificPpcUrl = exports.validateEmailDomain = exports.getSearchTextVariantsForASearchTerm = exports.getSearchTextVariants = void 0;
const capitalize_1 = __importDefault(require("lodash/capitalize"));
const cssxp_shared_1 = require("@atlassian/cssxp-shared");
const getSearchTextVariants = (key, value) => {
    const uniqueValues = (0, exports.getSearchTextVariantsForASearchTerm)(value);
    return [...uniqueValues].map((uniqueValue) => ({ [key]: uniqueValue }));
};
exports.getSearchTextVariants = getSearchTextVariants;
const getSearchTextVariantsForASearchTerm = (searchTerm) => {
    // Using `capitalize`, `startCase`, `toLowerCase` and `toUpperCase` to improve
    // the user experience and get results even if the search text was wrongly cased,
    if (!searchTerm) {
        return new Set([]);
    }
    // To improve: If we can ascertain the pattern of 'key' param, say 'invoiceNumber'
    // is always CAPS, then we can use only the applicable text variants
    const startCaseSearchText = searchTerm.replace(/\w+/g, capitalize_1.default);
    const upperCasedText = searchTerm.toUpperCase();
    const lowerCasedText = searchTerm.toLowerCase();
    const capitalizedText = (0, capitalize_1.default)(searchTerm);
    return new Set([searchTerm, capitalizedText, startCaseSearchText, upperCasedText, lowerCasedText]);
};
exports.getSearchTextVariantsForASearchTerm = getSearchTextVariantsForASearchTerm;
const validateEmailDomain = (email, validDomains) => {
    const domainFromEmail = email.split('@')[1];
    const matchedPartnerDomain = domainFromEmail && validDomains?.includes(domainFromEmail.toLowerCase());
    if (!matchedPartnerDomain)
        return `${email} must be from valid domain`;
};
exports.validateEmailDomain = validateEmailDomain;
const getEnvironmentSpecificPpcUrl = () => {
    const env = (0, cssxp_shared_1.getEnvironment)();
    return env === cssxp_shared_1.PRODUCTION ? 'https://ppc.atlassian.com' : 'https://ppc.stg.atlassian.com';
};
exports.getEnvironmentSpecificPpcUrl = getEnvironmentSpecificPpcUrl;
const getEnvironmentSpecificIdentityUrl = () => {
    const env = (0, cssxp_shared_1.getEnvironment)();
    return env === cssxp_shared_1.PRODUCTION ? 'https://id.atlassian.com' : 'https://id.stg.internal.atlassian.com';
};
exports.getEnvironmentSpecificIdentityUrl = getEnvironmentSpecificIdentityUrl;
